/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import AspectMultiMenu from "@/components/search/AspectMultiMenu";
import AspectRangeMenu from "@/components/search/AspectRangeMenu";
import AGE_OPTIONS from "@/constants/AgeOptions";
import HEIGHT_OPTIONS from "@/constants/HeightOptions";
import PRICE_OPTIONS from "@/constants/PriceOptions";
import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import { HomePageSearchResponse } from "@/models/HomePageSearchResponse";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import HeightIcon from "@mui/icons-material/Height";
import PersonIcon from "@mui/icons-material/Person";
import ChecklistIcon from "@mui/icons-material/Checklist";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import FemaleIcon from "@mui/icons-material/Female";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AspectToggle from "@/components/search/AspectToggle";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import AspectText from "@/components/search/AspectText";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import DEFAULT_SEARCH_REQUEST from "@/constants/DefaultSearchRequest";
import ClearIcon from "@mui/icons-material/Clear";
import AspectLocationMenu from "@/components/search/AspectLocationMenu";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { SaveButton } from "@/components/search/SaveButton";
import { JockeyIcon } from "@/app/shared/icons/JockeyIcon";
import { Z_INDEX_BACKDROP } from "@/app/layout/LayoutConstants";

export default function FiltersSection({
  searchResponse,
  searchRequest,
  onSearchRequestChange,
  isLoading,
  searchPath,
}: {
  searchResponse: HomePageSearchResponse;
  searchRequest: HomePageSearchRequest;
  onSearchRequestChange: (updates: any, skipRefresh: boolean) => void;
  isLoading?: boolean;
  searchPath: string;
}) {
  const ottDiscipline = searchResponse.disciplines.find(
    (option) => option.id === "234",
  );
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        background: "white",
        padding: theme.spacing(2, 1),
        borderRadius: 10,
        position: "relative",
        overflow: "hidden",
      })}
    >
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: Z_INDEX_BACKDROP,
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            sx={{
              color: "black",
            }}
          />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0,
            paddingLeft: 1,
            paddingRight: 1,
            marginBottom: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              marginRight: "auto",
            }}
          >
            <TuneRoundedIcon /> Filters
          </Typography>
          <SaveButton type="SEARCH" currentKey={searchPath} />
        </Box>
        <AspectMultiMenu
          title="Categories"
          label="Category"
          options={searchResponse.categories}
          selectedValues={searchRequest.categories}
          onChange={(categories, skipRefresh) =>
            onSearchRequestChange({ categories }, skipRefresh)
          }
          icon={<CategoryOutlinedIcon />}
        />
        <AspectMultiMenu
          title="Breeds"
          label="Breed"
          options={searchResponse.breeds}
          selectedValues={searchRequest.breeds}
          onChange={(breeds, skipRefresh) =>
            onSearchRequestChange({ breeds }, skipRefresh)
          }
          icon={<WaterDropOutlinedIcon />}
        />
        <AspectMultiMenu
          title="Disciplines"
          label="Discipline"
          options={searchResponse.disciplines}
          selectedValues={searchRequest.disciplines}
          onChange={(disciplines, skipRefresh) =>
            onSearchRequestChange({ disciplines }, skipRefresh)
          }
          icon={<ChecklistIcon />}
        />
        <AspectLocationMenu
          searchRequest={searchRequest}
          searchResponse={searchResponse}
          handleOnSearchRequestChange={onSearchRequestChange}
        />
        <AspectRangeMenu
          aspectKey="price"
          aspectLabel="Price"
          options={PRICE_OPTIONS}
          value={searchRequest.price}
          onChange={(price) => onSearchRequestChange({ price }, true)}
          icon={<AttachMoneyIcon />}
        />
        {searchResponse.isHorseVertical && (
          <>
            <AspectRangeMenu
              aspectKey="height"
              aspectLabel="Height"
              options={HEIGHT_OPTIONS}
              value={searchRequest.height}
              onChange={(height) => onSearchRequestChange({ height }, true)}
              icon={<HeightIcon />}
            />
            <AspectRangeMenu
              aspectKey="age"
              aspectLabel="Age"
              options={AGE_OPTIONS}
              value={searchRequest.age}
              onChange={(age) => onSearchRequestChange({ age }, true)}
              icon={<HourglassEmptyOutlinedIcon />}
            />
          </>
        )}
        <AspectMultiMenu
          title="Rider Levels"
          label="Rider Level"
          options={searchResponse.riderLevels}
          selectedValues={searchRequest.riderLevels}
          onChange={(riderLevels, skipRefresh) =>
            onSearchRequestChange({ riderLevels }, skipRefresh)
          }
          icon={<PersonIcon />}
        />
        <AspectMultiMenu
          title="Colours"
          label="Colour"
          options={searchResponse.colours}
          selectedValues={searchRequest.colours}
          onChange={(colours, skipRefresh) =>
            onSearchRequestChange({ colours }, skipRefresh)
          }
          icon={<ColorLensOutlinedIcon />}
        />
        <AspectMultiMenu
          title="Genders"
          label="Gender"
          options={searchResponse.genders}
          selectedValues={searchRequest.genders}
          onChange={(genders, skipRefresh) =>
            onSearchRequestChange({ genders }, skipRefresh)
          }
          icon={<FemaleIcon />}
        />
        {(!!searchRequest.hasVideo || searchResponse.videoAdsCount > 0) && (
          <AspectToggle
            label="Videos"
            icon={<PlayArrowIcon />}
            isSelected={!!searchRequest.hasVideo}
            onChange={(hasVideo) =>
              onSearchRequestChange({ hasVideo: hasVideo || null }, false)
            }
          />
        )}
        {ottDiscipline &&
          !searchRequest.disciplines.find((x) => x.id === ottDiscipline.id) && (
            <AspectToggle
              label="Off The Track"
              icon={
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                  }}
                >
                  <JockeyIcon size="small" />
                </Box>
              }
              isSelected={false}
              onChange={(isSelected) =>
                onSearchRequestChange(
                  {
                    disciplines: isSelected ? [ottDiscipline] : [],
                  },
                  false,
                )
              }
            />
          )}
        {(!!searchRequest.isUrgent || searchResponse.urgentAdsCount > 0) && (
          <AspectToggle
            label="Urgent"
            icon={<WhatshotIcon />}
            isSelected={!!searchRequest.isUrgent}
            onChange={(isUrgent) =>
              onSearchRequestChange({ isUrgent: isUrgent || null }, false)
            }
          />
        )}
        <AspectText
          value={searchRequest.searchQuery}
          onChange={(searchQuery) =>
            onSearchRequestChange({ searchQuery }, false)
          }
        />

        {searchResponse.selectedValuesCount > 0 && (
          <Typography
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              marginTop: 1,
              padding: theme.spacing(0.5, 1, 0.5, 2),
              borderRadius: "100px",
              cursor: "pointer",
              alignSelf: "flex-end",
              backgroundColor: "grey.100",
              ...theme.typography.button,
            })}
            onClick={() =>
              onSearchRequestChange(
                {
                  ...DEFAULT_SEARCH_REQUEST,
                  vertical: searchRequest.vertical,
                },
                false,
              )
            }
          >
            Clear All
            <IconButton
              size="small"
              sx={{
                color: "black",
              }}
            >
              <ClearIcon />
            </IconButton>
          </Typography>
        )}
      </Box>
    </Box>
  );
}
